import { useLocation } from 'react-router-dom';

import { homePath, forgotPasswordPath, changePasswordPath } from '@/v5/paths';
import { slideVariants, transition } from '@/v5/@constants/login';

/**
 * @note Specific custom hook for extracting animation values at Auth pages
 * */
function usePathnameDetect() {
    const location = useLocation();

    const _forgotPasswordPath = forgotPasswordPath();
    const _changePasswordPath = changePasswordPath();
    const _homePath = homePath();
    const isForgotPassword = location.pathname === _forgotPasswordPath;
    const isChangePassword = location.pathname === _changePasswordPath;

    // Define route hierarchy for proper direction mapping
    // Route hierarchy: login (center) ← forgot-password/change-password (right)
    // login → forgot-password/change-password: slide right to left
    // forgot-password/change-password → login: slide left to right
    const routesLevel = {
        login: 0,
        'forgot-password': 1,
        'change-password': 1,
    };

    const currentRoute = isForgotPassword
        ? 'forgot-password'
        : isChangePassword
          ? 'change-password'
          : 'login';

    const routes = {
        login: _homePath,
        'forgot-password': _forgotPasswordPath,
        'change-password': _changePasswordPath,
    };

    return {
        // for transition hook
        currentRoute,
        routes,
        routesLevel,

        // animation constants
        transition,
        slideVariants,

        // pathname detection
        isForgotPassword,
        isChangePassword,
    };
}

export { usePathnameDetect };
